export enum REPORT_TYPES  {
    MIXED = 'mixed',
    PLATE = 'plate'
}